<app-loader [loading]="loading"></app-loader>
<div class="app-content content">
  <div class="content-wrapper">
    <div class="content-body">
      <div class="wrapper fadeInleft bg-login-image">
        <div class="row align-items-center">
          <div class="col-lg-8 col-md-6 p-0 text-center login-brand">
            <img src="./assets/images/logo-wwtp.png" id="icon" alt="logo" />
            <img src="./assets/images/login-logo1.png" id="icon" alt="logo" />
          </div>
          <div class="col-lg-4 col-md-6 p-0 login-panel">
            <div id="formContent">
              <div class="login-form">
                <div class="login-tabar">
                  <button
                    class="btn login-tabs"
                    [ngClass]="{ 'login-active': isLogin == true }"
                    (click)="onClickLogin('login')">
                    LOGIN
                  </button>
                </div>
                <div *ngIf="isLogin == true">
                  <form
                    [formGroup]="loginForm"
                    (ngSubmit)="onLogin()"
                    id="loginForm">
                    <div class="login-formGroup">
                      <label class="login-label">Username</label>
                      <input
                        type="text"
                        id="login"
                        class="login-formcontrol"
                        formControlName="email"
                        name="username"
                        placeholder="Username"
                        autocomplete="off"
                        autocapitalize="none"
                        autocorrect="off"
                        spellcheck="false"
                        enterkeyhint="next" />
                    </div>
                    <div class="login-formGroup">
                      <label class="login-label">Password</label>
                      <input
                        type="text"
                        id="password"
                        class="login-formcontrol pastype"
                        formControlName="password"
                        name="login"
                        placeholder="**********"
                        [readonly]="btnDisabled == 1 ? true : false"
                        autocomplete="off"
                        autocapitalize="none"
                        autocorrect="off"
                        spellcheck="false"
                        enterkeyhint="go" />
                      <p *ngIf="errorMessage" class="error-message">
                        {{ errorMessage }}
                      </p>
                    </div>
                    <div class="col-lg-12 login-actions">
                      <button
                        type="submit"
                        class="btn login-btn"
                        [disabled]="loginForm.invalid || btnDisabled == 1 || isInitiatingLogin">
                        {{ isInitiatingLogin ? "Please wait..." : "Log In" }}
                      </button>
                      <button
                        type="button"
                        class="btn forget-btn"
                        (click)="forgot()">
                        Forgot Password
                      </button>
                    </div>
                    <p *ngIf="btnDisabled == 1" class="login-fail-class">
                      Login button has been disabled due to too many failed
                      attempts. Please try again in <b>{{ timeLeft }}</b>
                    </p>
                  </form>
                  <div class="seperator-text">Or</div>
                  <div>
                    <button
                      class="btn btn-social-icon btn-google"
                      (click)="signUp()">
                      <span>SIGNUP</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<p-dialog
  header="Verify OTP"
  [(visible)]="showOtpDialog"
  [modal]="true"
  [closable]="!isOtpSubmitting"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '28rem', maxWidth: '95vw' }"
  (onHide)="closeOtpDialog()">
  <div class="otp-dialog-content">
    <p class="otp-dialog-text">
      Enter the 6 digit OTP sent to your registered email address.
    </p>
    <p *ngIf="otpDestination" class="otp-dialog-text">
      OTP sent to <strong>{{ otpDestination }}</strong>
    </p>

    <form [formGroup]="otpForm" (ngSubmit)="submitOtp()" class="otp-dialog-form">
      <p-inputOtp
        formControlName="otp"
        [length]="6"
        [integerOnly]="true"
        styleClass="w-100">
      </p-inputOtp>

      <p
        *ngIf="otpForm.get('otp')?.invalid && otpForm.get('otp')?.touched"
        class="error-message otp-error">
        Please enter a valid 6 digit OTP.
      </p>

      <p *ngIf="otpErrorMessage" class="error-message otp-error">
        {{ otpErrorMessage }}
      </p>

      <div class="otp-dialog-actions otp-dialog-actions-secondary">
        <button
          type="button"
          class="btn forget-btn otp-secondary-btn"
          (click)="resendOtp()"
          [disabled]="isOtpSubmitting || isOtpResending || otpResendSeconds > 0">
          {{
            isOtpResending
              ? "Resending..."
              : otpResendSeconds > 0
                ? "Resend OTP in " + otpResendSeconds + "s"
                : "Resend OTP"
          }}
        </button>
      </div>

      <div class="otp-dialog-actions">
        <button
          type="button"
          class="btn forget-btn otp-secondary-btn"
          (click)="closeOtpDialog()"
          [disabled]="isOtpSubmitting">
          Cancel
        </button>
        <button
          type="submit"
          class="btn login-btn otp-primary-btn"
          [disabled]="otpForm.invalid || isOtpSubmitting">
          {{ isOtpSubmitting ? "Verifying..." : "Verify OTP" }}
        </button>
      </div>
    </form>
  </div>
</p-dialog>
